import type { RelatoriosPayload } from '@/types/interfaces/RelatoriosPayload';
import { router } from '@/router/Router';

const TIME_TO_REMOVE_IFRAME = 60_000 * 10; // 10 minutes

export function printPDF(url: string): void {
    const iframe = document.createElement('iframe');

    iframe.style.display = 'none';
    iframe.src = url;

    // Also clean up when the PDF viewer never fires its load event.
    const cleanupTimeout = window.setTimeout(() => {
        iframe.remove();
    }, TIME_TO_REMOVE_IFRAME);

    const cleanup = (): void => {
        window.clearTimeout(cleanupTimeout);
        iframe.remove();
    };

    iframe.onload = () => {
        // A native PDF viewer can be isolated even for a same-origin blob URL.
        try {
            const printWindow = iframe.contentWindow;

            if (!printWindow) {
                cleanup();
                return;
            }

            printWindow.focus();
            printWindow.print();

            // Keep the PDF alive while the browser's print dialog is open.
            window.clearTimeout(cleanupTimeout);
            window.setTimeout(cleanup, TIME_TO_REMOVE_IFRAME);
        } catch {
            cleanup();
            // Let the user print from the browser's PDF toolbar instead.
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    };

    document.body.appendChild(iframe);
}

export function openPDF({
    type,
    authenticated,
    link,
    relatorios,
    autoPrint = false,
}: {
    type: 'file' | 'link';
    authenticated: boolean;
    link?: string;
    relatorios?: RelatoriosPayload;
    autoPrint?: boolean;
}): void {
    sessionStorage.setItem('pdf-type', type);

    sessionStorage.setItem(
        'pdf-source',
        type === 'link' ? link || '' : JSON.stringify(relatorios || null),
    );

    sessionStorage.setItem('pdf-autoprint', String(autoPrint));

    void router.navigate({
        params: { filetype: 'pdf' },
        to: authenticated ? '/a/impressao/$filetype' : '/p/impressao/$filetype',
    });
}
